<template>
  <!-- <div @click="$sidebar.displaySidebar(false)"> -->
  <div v-if="loadComplete">
    <fade-transition :duration="200" origin="center top" mode="out-in">
      <router-view :key="activeProjectId"></router-view>
    </fade-transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { FadeTransition } from 'vue2-transitions';

export default {
  components: {
    FadeTransition,
  },
  computed: {
    ...mapGetters('user', {
      isEmailVerified: 'isEmailVerified',
      userNeedsOnboard: 'userNeedsOnboard',
    }),
    ...mapGetters({
      loadComplete: 'isInitialLoadComplete',
      activeProjectId: 'activeProjectId',
    }),
  },
};
</script>
